function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "6",
  height: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#DADCDF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "1",
  cy: "1",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "1",
  cy: "5",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "1",
  cy: "9",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "1",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "5",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "9",
  r: "1"
}))));